import { createFileRoute, Outlet } from "@tanstack/react-router";
import { MarketingLayout } from "@/features/marketing/marketing-layout";

/** Pathless layout for the public pages: `/`, `/features`, `/pricing`, `/contact` and the free planning tools. */
export const Route = createFileRoute("/_marketing")({
  component: () => (
    <MarketingLayout>
      <Outlet />
    </MarketingLayout>
  ),
});
